export const GET_STRATEGIC_RELATIONSHIPS_SUCCESS =
  'GET_STRATEGIC_RELATIONSHIPS_SUCCESS';
export const GET_STRATEGIC_RELATIONSHIPS_FAILURE =
  'GET_STRATEGIC_RELATIONSHIPS_FAILURE';

export const POST_STRATEGIC_RELATIONSHIPS_SUCCESS =
  'POST_STRATEGIC_RELATIONSHIPS_SUCCESS';
export const POST_STRATEGIC_RELATIONSHIPS_FAILURE =
  'POST_STRATEGIC_RELATIONSHIPS_FAILURE';
